import { ref, computed, watch } from 'vue'
import { deepClone } from '@/utils/util'
import { ANSWER_PREFIX } from '../utils'
export const EMIT_OPTIONS = ['on-change']
export function useCommon(props, emit) {
  const copyItem = ref({})
  const filterSelect = computed(() => {
    return function(list) {
      const newList = JSON.parse(JSON.stringify(list))
      const strArr = []
      if (copyItem.value.submitAnswer) {
        const submitAnswerArr = copyItem.value.submitAnswer.split(',')
        submitAnswerArr.forEach((submitAnswerItem, index) => {
          newList.forEach((item, ind) => {
            item.titleStr = ANSWER_PREFIX[ind]
            if (item.examAnswerId == submitAnswerItem) {
              item.sortNum = index + 1
              strArr.push(item.titleStr)
            }
          })
        })
      }
      return strArr.join('、')
    }
  })

  const filterCorrect = computed(() => {
    return function(list) {
      const newList = JSON.parse(JSON.stringify(list))
      const strArr = []
      if (copyItem.value.examAnswerResults) {
        copyItem.value.examAnswerResults.forEach((it, index) => {
          newList.forEach((item, ind) => {
            item.titleStr = ANSWER_PREFIX[ind]
            if (item.examAnswerId == it.correctAnswer) {
              item.sortNum = index + 1
              strArr.push(item.titleStr)
            }
            return item
          })
        })
      }
      return strArr.join('、')
    }
  })

  function initItem(newVal) {
    copyItem.value = deepClone(newVal)
    if (copyItem.value.submitAnswer) {
      const { submitAnswer } = copyItem.value
      copyItem.value.answers = copyItem.value.answers?.map(item => {
        item.isSelect = submitAnswer.split(',').map(item => Number(item)).includes(item.examAnswerId)
        return item
      })
    } else {
      copyItem.value.answers = copyItem.value.answers?.map(item => {
        item.isSelect = false
        return item
      })
    }
  }

  function handleClick(row, answerItem) {
    if (props.beforeChange(row, answerItem)) {
      copyItem.value.answers = copyItem.value.answers.map(item => {
        if (item.examAnswerId === answerItem.examAnswerId) {
          item['isSelect'] = !item['isSelect']
        } else {
          item['isSelect'] = false
        }
        return item
      })
      emit('on-change', copyItem.value)
    }
  }

  function validate({ success, fail }) {
    let isNeedRelationExamAnswer = false
    const flag = copyItem.value.answers.some(item => {
      if (item.needRelationExamAnswer) {
        isNeedRelationExamAnswer = true
        return item.relationExamAnswerIds && item.isSelect
      }
      isNeedRelationExamAnswer = false
      return item.isSelect
    })
    if (flag) {
      success()
    } else {
      fail({
        row: copyItem.value,
        message: isNeedRelationExamAnswer ? '请选择关联检查项' : '请选择答案'
      })
    }
  }

  function onSubmit() {
    return new Promise((resolve, reject) => {
      validate({
        success: () => {
          const relationExamAnswerIds = {}
          const stringVal = copyItem.value.answers.map(item => {
            if (item.relationExamAnswerIds) {
              relationExamAnswerIds[item.examAnswerId] = item.relationExamAnswerIds
            }
            if (item.isSelect) {
              return item.examAnswerId
            }
          }).filter(item => item).join(',')

          copyItem.value.submitAnswerObj = {
            intVal: copyItem.value.examId,
            stringVal
          }
          if (Object.keys(relationExamAnswerIds).length) {
            copyItem.value.submitAnswerObj.relationExamAnswerIds = relationExamAnswerIds
          }

          resolve(copyItem.value)
        },
        fail: error => {
          reject(error)
        }
      })
    })
  }

  function reset() {
    initItem(props.item)
  }

  // 监听 item 的变化
  watch(() => props.item, newVal => {
    initItem(newVal)
  }, {
    immediate: true,
    deep: true
  })

  return {
    copyItem,
    filterCorrect,
    filterSelect,
    onSubmit,
    reset,
    handleClick
  }
}
